import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import dayjs from 'dayjs';

const DateRangeFilter = ({ start, end, onStart, onEnd, onSubmit, extra }) => (
  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 3 }}>
    <TextField
      label="Start Date" type="date" size="small"
      value={start} onChange={e => onStart(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
    <TextField
      label="End Date" type="date" size="small"
      value={end} onChange={e => onEnd(e.target.value)}
      InputLabelProps={{ shrink: true }}
    />
    {extra}
    <Button variant="contained" onClick={onSubmit}>Run</Button>
  </Box>
);

export const defaultStart = () => dayjs().subtract(7, 'day').format('YYYY-MM-DD');
export const defaultEnd = () => dayjs().format('YYYY-MM-DD');

export default DateRangeFilter;
